import { CustomerData } from "@/api/order";
import { Separator } from "@/components/ui/separator";

interface CustomerLineProp {
  title: string;
  data: string;
}

export const CustomerLine = ({ title, data }: CustomerLineProp) => {
  return (
    <div className="flex flex-row justify-between text-sm">
      <span className="font-semibold flex-1 text-left">{title}</span>
      <span className="flex-1 text-right">{data}</span>
    </div>
  );
};

export const CustomerInfoRecap = ({
  customer,
  paymentMethod,
}: {
  customer: CustomerData;
  paymentMethod: string;
}) => {
  const content: CustomerLineProp[] = [
    {
      title: "Tel",
      data: customer.phone,
    },
    {
      title: "Mail",
      data: customer.email,
    },
    {
      title: "Adresse de livraison",
      data: `${customer.billingAdress.adress} \n${customer.billingAdress.postalCode} ${customer.billingAdress.city}`,
    },
    {
      title: "Payé par",
      data: paymentMethod,
    },
  ];

  return (
    <div className="border border-solid border-gray-300 rounded-xl flex flex-col p-4 gap-2">
      <span className="font-semibold text-lg">{customer.name}</span>
      {content.map((c, i) => (
        <div className="flex flex-col justify-between gap-2" key={c.title}>
          <CustomerLine {...c} />
          {i !== content.length - 1 && <Separator />}
        </div>
      ))}
    </div>
  );
};
